import { render, staticRenderFns } from "./TagRich.vue?vue&type=template&id=abc04d86"
import script from "./TagRich.vue?vue&type=script&lang=js"
export * from "./TagRich.vue?vue&type=script&lang=js"
import style0 from "./TagRich.vue?vue&type=style&index=0&id=abc04d86&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports